export default __webpack_public_path__ + "static/media/happymile-logo.24b3a0f1.svg";